<template>
  <MapControlButton
    v-access="'fields_edit'"
    :isActive="mode === 'group-edit-field'"
    title="Массовое редактирование полей"
    @onClick="clickEditFieldGroup"
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" fill="currentColor" />
      <rect width="392" height="776" transform="translate(-104 -729)" fill="white" />
      <path d="M3 17.0156V3H17.0156V17.0156H3ZM3 0.984375C2.46875 0.984375 2 1.1875 1.59375 1.59375C1.1875 2 0.984375 2.46875 0.984375 3V17.0156C0.984375 17.5469 1.1875 18.0156 1.59375 18.4219C2 18.7969 2.46875 18.9844 3 18.9844H17.0156C17.5469 18.9844 18.0156 18.7969 18.4219 18.4219C18.7969 18.0156 18.9844 17.5469 18.9844 17.0156V3C18.9844 2.46875 18.7969 2 18.4219 1.59375C18.0156 1.1875 17.5469 0.984375 17.0156 0.984375H3ZM21 5.01562V21H5.01562V23.0156H21C21.5312 23.0156 22 22.8125 22.4062 22.4062C22.8125 22 23.0156 21.5312 23.0156 21V5.01562H21Z" fill="currentColor" />
      <path d="M15.2227 6.80859L14.2324 7.79883L12.2012 5.76758L13.1914 4.77734C13.293 4.67578 13.4199 4.625 13.5723 4.625C13.7246 4.625 13.8516 4.67578 13.9531 4.77734L15.2227 6.04688C15.3242 6.14844 15.375 6.27539 15.375 6.42773C15.375 6.58008 15.3242 6.70703 15.2227 6.80859ZM5.625 12.3438L11.6172 6.35156L13.6484 8.38281L7.65625 14.375H5.625V12.3438Z" fill="currentColor" />
    </svg>
  </MapControlButton>

  <MapControlButton
    v-access="'fields_join'"
    :isActive="mode === 'join-fields'"
    title="Объединение полей"
    @onClick="clickJoinFields"
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" d="M3,1C1.89,1 1,1.89 1,3V14C1,15.11 1.89,16 3,16C4.33,16 7,16 7,16C7,16 7,18.67 7,20C7,21.11 7.89,22 9,22H20C21.11,22 22,21.11 22,20V9C22,7.89 21.11,7 20,7C18.67,7 16,7 16,7C16,7 16,4.33 16,3C16,1.89 15.11,1 14,1H3M3,3H14C14,4.33 14,7 14,7H9C7.89,7 7,7.89 7,9V14C7,14 4.33,14 3,14V3M9,9H14V14H9V9M16,9C16,9 18.67,9 20,9V20H9C9,18.67 9,16 9,16H14C15.11,16 16,15.11 16,14V9Z" />
    </svg>
  </MapControlButton>

  <MapControlButton
    v-access="'fields_view'"
    :isActive="mode === 'create-field-paint' || mode === 'create-field-section'"
    title="Создание поля"
    @onClick="isShowFieldCreateMenu = !isShowFieldCreateMenu"
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 17.0156V3H17.0156V17.0156H3ZM3 0.984375C2.46875 0.984375 2 1.1875 1.59375 1.59375C1.1875 2 0.984375 2.46875 0.984375 3V17.0156C0.984375 17.5469 1.1875 18.0156 1.59375 18.4219C2 18.7969 2.46875 18.9844 3 18.9844H17.0156C17.5469 18.9844 18.0156 18.7969 18.4219 18.4219C18.7969 18.0156 18.9844 17.5469 18.9844 17.0156V3C18.9844 2.46875 18.7969 2 18.4219 1.59375C18.0156 1.1875 17.5469 0.984375 17.0156 0.984375H3ZM21 5.01562V21H5.01562V23.0156H21C21.5312 23.0156 22 22.8125 22.4062 22.4062C22.8125 22 23.0156 21.5312 23.0156 21V5.01562H21Z" fill="currentColor" />
      <path d="M14.0742 10.5742H10.5742V14.0742H9.42578V10.5742H5.92578V9.42578H9.42578V5.92578H10.5742V9.42578H14.0742V10.5742Z" fill="currentColor" />
    </svg>

    <div v-if="isShowFieldCreateMenu" aria-label="Меню выбора способа создания поля" class="layer-list">
      <div class="layer-list-menu">
        <ul>
          <li :class="{active: mode === 'create-field-paint'}" @click.stop="setCreateFieldMode('create-field-paint')">
            Рисование
          </li>
          <li :class="{active: mode === 'create-field-section'}" @click.stop="setCreateFieldMode('create-field-section')">
            Из участка
          </li>
          <li v-if="mode === 'create-field-paint' || mode === 'create-field-section'" @click="cancelFieldCreate">
            Отмена
          </li>
        </ul>
      </div>
      <div class="layer-list-triangle"></div>
    </div>
  </MapControlButton>
</template>
<script setup>
import { ref, computed, watch } from 'vue'
import { useStore } from 'vuex'
import MapControlButton from './MapControlButton'

const store = useStore()

const isShowFieldCreateMenu = ref(false)

const mode = computed(() => store.state.map.mode)

const clickEditFieldGroup = () => {
  store.commit('fields/setGroupEditingFields', [])
  store.commit('map/setMode', mode.value === 'group-edit-field' ? 'default' : 'group-edit-field')
}

const clickJoinFields = () => {
  store.commit('map/setMode', mode.value === 'join-fields' ? 'default' : 'join-fields')
}

const setCreateFieldMode = (value) => {
  store.commit('map/setMode', value)
}

const cancelFieldCreate = () => {
  store.commit('map/setMode', 'default')
}

watch(mode, (value) => {
  if (value !== 'create-field-paint' && value !== 'create-field-section') {
    isShowFieldCreateMenu.value = false
  }
})
</script>
<style lang="scss" scoped>
.controls-button {
  cursor: pointer;
  display: flex;
  justify-content: center;
  box-sizing: content-box;
  align-items: center;
  font-size: 43px;
  width: 40px;
  height: 40px;
  background-color: #ffffff;
  color: #2f3e4d;
  position: relative;
  border: 2px solid rgba(191, 191, 191, 0.45);
  font-size: 20px !important;
  border-radius: 8px;

  &:hover,
  &.active {
    color: $color-active;
  }
}

.layer-list {
  border-radius: 4px;

  .layer-list-menu {
    width: 133px;
    background: #FFFFFF;
    border-radius: 4px;
    position: absolute;
    left: -148px;
    top: -45px;
    display: flex;
    padding: 10px 0;

    ul {
      list-style: none;
      padding-left: 0;
      margin-bottom: 0;
      margin-top: 0;
      width: 100%;

      li {
        cursor: pointer;
        display: flex;
        align-items: center;
        font-size: 12px;
        line-height: 16px;
        color: #2F3E4D;
        padding: 12px 16px;

        &:first-child {
          border-radius: 4px 4px 0 0;
        }

        &.active {
          color: $color-active;
        }

        &:hover {
          background: #F7F9FC;
        }
      }
    }
  }

  .layer-list-triangle {
    height: 50%;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 13px solid #ffffff;
    position: absolute;
    left: -18px;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
